import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { createVehicleTypeAsync, fetchVehicleTypes, getVehicleTypesOverview } from '../../../store/Slices/VehicleTypeSlice';
import { vehicleTypeValidationSchema } from '../../../utils/Schema';
import { vehicleTypeStatusOptions, vehicleClassOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const CreateVehicleTypeModal = ({ show, onHide, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { createVehicleTypeLoading } = useSelector((state) => state.vehicleTypes);

    const initialValues = {
        title: '',
        status: 'active',
        vehicle_class: 'pool'
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            await dispatch(createVehicleTypeAsync(values)).unwrap();
            successNotify('Vehicle type created successfully');
            resetForm();
            onHide();
            
            // Refresh table and overview
            dispatch(fetchVehicleTypes({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getVehicleTypesOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Add Vehicle Type" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={vehicleTypeValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Vehicle Type Information</h5>
                            <div>
                                <Input
                                    label="Title"
                                    placeholder="Enter vehicle type title"
                                    type="text"
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title}
                                    touched={touched.title}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Vehicle Class"
                                    placeholder="Select vehicle class"
                                    options={vehicleClassOptions}
                                    name="vehicle_class"
                                    value={vehicleClassOptions.find(opt => opt.value === values.vehicle_class)}
                                    onChange={(option) => setFieldValue('vehicle_class', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.vehicle_class}
                                    touched={touched.vehicle_class}
                                />
                                <Select
                                    label="Status"
                                    placeholder="Select status"
                                    options={vehicleTypeStatusOptions}
                                    name="status"
                                    value={vehicleTypeStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={createVehicleTypeLoading || isSubmitting}
                                    disabled={createVehicleTypeLoading || isSubmitting}
                                    submitText="Save"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default CreateVehicleTypeModal;
